import React, { memo } from 'react';

import classNames from 'classnames';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import cls from '../MassActionsPanel.module.css';
import { useEditBlock } from './useEditBlock';
import { RoundingOption } from '../RoundingOption/RoundingOption';

export const EditBlock = memo(({ activeSelect, setActiveSelect }) => {
    const {
        rename,
        changeMargin,
        changePrice,
        changeCustomerPrice,
        changeUnit,
        remove,
        isShowRoundingOption,
        onEditRoundingOption,
        onClickRoundingOption,
    } = useEditBlock(setActiveSelect);
    const { t } = useTranslation();

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                if (activeSelect === 'edit') {
                    setActiveSelect('');
                } else {
                    setActiveSelect('edit');
                }
            }}
            className={cls.select}
        >
            <span>{t('EditBlock.ChangeBtn.text')}</span>
            <div
                className={classNames(cls.svgWrapper, {
                    [cls.active]: activeSelect === 'edit',
                })}
            >
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4.95316 6.33337L3.95316 7.33337L8.00003 11.3802L12.0469 7.33337L11.0469 6.33337L8.00003 9.38025L4.95316 6.33337Z"
                        fill="white"
                    />
                </svg>
            </div>
            <div
                className={classNames(cls.actionsGroupList, {
                    [cls.activeList]: activeSelect === 'edit',
                })}
            >
                <div onClick={(e) => rename(e)} className={classNames(cls.listItem, cls.rename)}>
                    {t('EditBlock.RenameBtn.text')}
                </div>
                {!isGeneralDirectory && (
                    <div onClick={(e) => changeMargin(e)} className={cls.listItem}>
                        {t('EditBlock.ChangeMarginBtn.text')}
                    </div>
                )}
                {!isGeneralDirectory && (
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            onClickRoundingOption();
                        }}
                        className={cn(cls.listItem, cls.between)}
                    >
                        {isShowRoundingOption && (
                            <RoundingOption onEditRoundingOption={onEditRoundingOption} />
                        )}
                        <span>{t('EditBlock.ChangeRounding.text')}</span>
                        <span
                            className={classNames(
                                cls.listItemArrow,
                                isShowRoundingOption && cls.listItemArrowOpen
                            )}
                        >
                            <svg
                                width="9"
                                height="6"
                                viewBox="0 0 9 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1.90625 0.476563L0.90625 1.47656L4.95313 5.52344L9 1.47656L8 0.476563L4.95313 3.52344L1.90625 0.476563Z"
                                    fill="white"
                                />
                            </svg>
                        </span>
                    </div>
                )}
                <div className={cls.listItem} onClick={(e) => changePrice(e)}>
                    {t('EditBlock.ChangePrice.text')}
                </div>
                {!isGeneralDirectory && (
                    <div onClick={(e) => changeCustomerPrice(e)} className={cls.listItem}>
                        {t('EditBlock.ChangeCustomerPrice.text')}
                    </div>
                )}
                <div className={cls.listItem} onClick={(e) => changeUnit(e)}>
                    {t('EditBlock.ChangeUnit.text')}
                </div>
                <div onClick={(e) => remove(e)} className={classNames(cls.listItem, cls.delete)}>
                    {t('EditBlock.Delete.text')}
                </div>
            </div>
        </button>
    );
});
